var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaddleFl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 28",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#EA2E2E",
    strokeWidth: 1.5,
    cx: 9,
    cy: 17.947,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23 5.75H.75l.004 15.829a3.66 3.66 0 001.076 2.595 3.66 3.66 0 002.596 1.075l18.824-.253L23 5.75zM15.36.75H4a3.24 3.24 0 00-2.298.952A3.24 3.24 0 00.75 4v1.745h17.077L15.36.75z",
    stroke: "#000",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    fill: "#000",
    x: 7,
    y: 11.526,
    width: 10,
    height: 1.5,
    rx: 0.737
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaddleFl);
export default __webpack_public_path__ + "static/media/PaddleFL.44ed1336.svg";
export { ForwardRef as ReactComponent };